export default __webpack_public_path__ + "static/media/41t.41df88c9.jpg";